export default __webpack_public_path__ + "static/media/Armbands of the Usurper.363c6f10.jpg";